(function($) {
    $.widget("ca.caSwitcher", {
        options: {
            onChange : function() {}
        },
        _create : function() {
            var self = this;
            var element = this.element;
            element.find('br').remove();

            $.each(element.find('label'), function(k, v) {
                var item = $(v);
                var input = item.find('input');
                item.html('<span>'+ item.html() +'</span>');
                
                if (input.is(':checked') ||
                    item.find('#' + input.prop('id')).is(':checked')) { //hack for IE, dont know why it is workng
                    item.addClass('active');
                }
                item.on('click', function() {
                    //chek if selected
                    var isActive = $(this).hasClass('active');
                    $(this).closest('.ca-switcher').find('.active').removeClass('active').find('input').prop('checked', false);
                    $(this).addClass('active').find('input').prop('checked' , 'checked');
                    
                    if(!isActive) {
                        //update when chaged to active from non active
                        self.options.onChange();
                    }
                });
            });

            element.find('label:last').addClass('last-child');
        },
        
        setOnChange: function(callback) {
            this.options.onChange = callback;
        }
    });
})(jQuery);